export const footerConfig = {

    text: [
        {id:1, text:'Take a Coffee & Chat With Me', isColored: false }
        
    ],
    thankyou: [
        {id:1, text:"Thank you for your request, I'll Soon Contact You", isColored: false }
    ]
}